import { render, staticRenderFns } from "./SalaryCheckPage.vue?vue&type=template&id=2c23f6b8&scoped=true"
import script from "./SalaryCheckPage.vue?vue&type=script&lang=js"
export * from "./SalaryCheckPage.vue?vue&type=script&lang=js"
import style0 from "./SalaryCheckPage.vue?vue&type=style&index=0&id=2c23f6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23f6b8",
  null
  
)

export default component.exports